import { Box, Flex } from "grid-styled";
import querystring from "querystring";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import infraMonitorService from "../../../api/infraMonitorService";
import {
  ContainerLeft,
  ContainerRight,
  Loader,
  Page,
  Pagination,
  ProjectStatusChart,
  Search,
  Tabs,
} from "../../../components/layouts";
import { Heading, Text } from "../../../components/styled";
import { images } from "../../../config/index";
import {
  getLocalList,
  getLocalListSuccess,
  setLocalFilters,
} from "../../../infraMonitor/localActions";
import {
  commonLocalization,
  number,
  projectsLocalization,
} from "../../../localization";
import FilterTags from "./filterTags";
import LocalProjectTable from "./partials/project-table";
import Filter from "./filter";

class LocalProjectList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPage: props.pagination.current_page,
      searchValue: "",
      selectedYear: props.fiscalYear,
      removedFilter: "",
      selectedProjectType: "local-projects",
    };

    this.municipality = this.props.municipality;
  }

  componentDidMount() {
    const { getDataList, location, fiscalYear } = this.props;

    const rawQueryParams = location.search
      ? querystring.parse(location.search.replace(/^\?/, ""))
      : {};

    const normalizedQueryParams = {};
    Object.keys(rawQueryParams).forEach((key) => {
      normalizedQueryParams[key] = Array.isArray(rawQueryParams[key])
        ? rawQueryParams[key][0]
        : rawQueryParams[key];
    });

    const requestParams = {
      fiscal_year: normalizedQueryParams["fiscal_year"] || fiscalYear,
      ...normalizedQueryParams,
    };

    getDataList(requestParams, this.municipality);
  }

  UNSAFE_componentWillReceiveProps(prevProps) {
    if (this.state.selectedYear !== prevProps.fiscalYear) {
      this.setState(
        {
          selectedYear: prevProps.fiscalYear,
        },
        () => {
          this.setQueryString({
            ...prevProps.filters,
            fiscal_year: prevProps.fiscalYear,
          });
          this.props.getDataList(
            {
              ...prevProps.filters,
              fiscal_year: prevProps.fiscalYear,
            },
            this.municipality
          );
        }
      );
    }
  }

  setQueryString = (filters) => {
    const query = Object.keys(filters).length
      ? `&${querystring.stringify(filters)}`
      : "";

    this.props.history.push({
      search: `page=1${query}`,
    });
  };

  filterData = (filters) => {
    const { getDataList, fiscalYear } = this.props;
    const selectedFilters = {
      ...filters,
      fiscal_year: fiscalYear,
      title: this.state.searchValue,
    };
    this.setQueryString(selectedFilters);
    getDataList(selectedFilters, this.municipality);
  };

  removeFilter(key) {
    const { filters, getDataList } = this.props;

    let filtersResult = {
      ...filters,
      [key]: "",
    };

    this.setQueryString(filtersResult);
    getDataList(filtersResult, this.municipality);
    this.setState({ removedFilter: key });
  }

  resetRemovedFilterState = () => {
    this.setState({ removedFilter: "" });
  };

  onSearchChange = (val) => {
    const { getDataList, filters } = this.props;

    this.setState(
      {
        searchValue: val,
      },
      () => {
        this.setQueryString({ ...filters, title: val });
        getDataList({ ...filters, title: val }, this.municipality);
      }
    );
  };

  sortByType = (title, type) => {
    const { getDataList, filters } = this.props;
    getDataList(
      { ...filters, sort_by: title, order_by: type },
      this.municipality
    );
  };

  handleChangePagination = (pageIndex) => {
    const { getDataListForPagination, filters } = this.props;

    const query = querystring.parse(
      this.props.location.search.replace("?", "")
    );

    query.page = pageIndex.selected + 1;
    this.props.history.push({
      search: `?${querystring.stringify(query)}`,
    });

    getDataListForPagination(
      { ...filters, page: pageIndex.selected + 1 },
      this.municipality
    );
  };

  render() {
    const {
      pagination,
      fetching,
      selectedLanguage,
      projects,
      filters,
      stats,
      loading,
      municipality,
    } = this.props;

    const { searchPlaceholder } = projectsLocalization[selectedLanguage];

    const { dataNotAvailable } = commonLocalization[selectedLanguage];

    return (
      <React.Fragment>
        {fetching && <Loader />}
        <Page className='project-list' lang={selectedLanguage}>
          <ContainerLeft>
            <TopWrap>
              <Search
                onSearchChange={this.onSearchChange}
                placeholder={searchPlaceholder}
              />
              <Flex className='top-right-wrap'>
                <Box>
                  {!loading && (
                    <Filter
                      filterData={this.filterData}
                      municipality={municipality}
                      removedFilter={this.state.removedFilter}
                      resetRemovedFilterState={this.resetRemovedFilterState}
                    />
                  )}
                </Box>
              </Flex>
            </TopWrap>
            <FilterTags
              filters={filters}
              removeFilter={(key) => this.removeFilter(key)}
            />
            {selectedLanguage === "en" ? (
              <WardProjectList>
                {filters.ward === "" ? (
                  <Heading.h2>Project list for all wards</Heading.h2>
                ) : (
                  <Heading.h2>
                    Project list for <strong>ward {filters.ward}</strong>
                  </Heading.h2>
                )}
              </WardProjectList>
            ) : (
              <WardProjectList>
                {filters.ward === "" ? (
                  <Heading.h2>सबै वडा का लागि कूल परियाेजनाहरु</Heading.h2>
                ) : (
                  <Heading.h2>
                    <strong>वडा {number(filters.ward)}</strong> का लागि कूल
                    परियाेजनाहरु
                  </Heading.h2>
                )}
              </WardProjectList>
            )}
            <Fragment>
              <TableWrap>
                {!!projects.length && (
                  <LocalProjectTable
                    sortByType={(title, type) => this.sortByType(title, type)}
                    projects={projects}
                  />
                )}
                {!projects.length && !fetching && (
                  <div className='data-not-available'>
                    <img
                      src={images.dataNotAvailable}
                      alt='data not available'
                    />
                    <Text.span lighter>{dataNotAvailable}</Text.span>
                  </div>
                )}
              </TableWrap>
            </Fragment>
            {projects.length && !fetching ? (
              <Pagination
                pagination={pagination}
                handleChangePagination={this.handleChangePagination.bind(this)}
              />
            ) : (
              ""
            )}
          </ContainerLeft>
          <ContainerRight>
            <div className='chart-block--status'>
              <Fragment>
                <ProjectStatusChart
                  wardValue={filters.ward}
                  stats={stats}
                  total={pagination.total}
                  navigateToProject={this.navigateToProject}
                  selectedProjectType={this.state.selectedProjectType}
                />
              </Fragment>
            </div>
          </ContainerRight>
        </Page>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  projects: state.localInfraMonitor.projects,
  pagination: state.localInfraMonitor.pagination,
  stats: state.localInfraMonitor.stats,
  fetching: state.localInfraMonitor.fetching,
  filters: state.localInfraMonitor.filters,
  selectedLanguage: state.localizationReducers.selectedLanguage,
  fiscalYear: state.fiscalYearReducers.selectedFiscalYear,
  loading: state.staticData.loading,
});

const mapDispatchToProps = (dispatch) => {
  const getLocalProjectListRequest = (filters, municipality) => {
    dispatch(getLocalList());
    infraMonitorService
      .getLocalProjectList(filters, municipality.title_en)
      .then((response) => {
        const { data, metadata } = response;
        dispatch(
          getLocalListSuccess({
            projects: data,
            pagination: metadata.pagination,
            stats: metadata.stats,
          })
        );
      });
  };

  return {
    getDataList: (filters, municipality) => {
      getLocalProjectListRequest(filters, municipality);
      dispatch(setLocalFilters(filters));
    },

    getDataListForPagination: (filters, municipality) => {
      getLocalProjectListRequest(filters, municipality);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LocalProjectList);

const TopWrap = styled.div`
  @media all and (min-width: 600px) and (max-width: 991px),
    (min-width: 1200px) {
    display: flex;
    justify-content: space-between;
    margin: 0;
  }
  .top-right-wrap {
    align-items: center;
    justify-content: space-between;
    width: 100%;
    > div:first-child {
      margin-right: 10px;
    }
    @media all and (min-width: 600px) and (max-width: 991px),
      (min-width: 1200px) {
      width: 46%;
    }
  }
`;

const TableWrap = styled.div`
  .status {
    border-radius: 11px;
    padding: 4px 10px;
    text-transform: capitalize;
  }
  .status--submitted {
    background-color: ${(props) => props.theme.sec.blue};
  }

  .status--evaluated {
    background-color: ${(props) => props.theme.sec.green};
  }

  .data-not-available {
    margin-top: 100px;
    text-align: center;
    span {
      display: block;
      font-size: 16px;
      margin-top: 20px;
    }
  }

  .ward-num {
    li {
      display: inline-block;
      & + li:before {
        content: ",";
        margin-right: 4px;
      }
    }
  }

  .progress__bar--line {
    align-items: center;
    display: flex;
    font-size: 10px;
  }

  .progress__total {
    background-color: ${(props) => props.theme.dark.charcoalGrey};
    border-radius: 8px;
    height: 8px;
    margin-right: 5px;
    width: 82%;
    overflow: hidden;
    & + .progress__total {
      margin-top: 10px;
    }
  }

  .progress {
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    display: block;
    height: 8px;
  }

  .progress__physical {
    background-color: ${(props) => props.theme.primary.pissYellow};
  }

  .progress__financial {
    background-color: ${(props) => props.theme.primary.white};
  }

  .progress__total--physical,
  .progress__total--financial {
    border-radius: 6px;
  }

  .title__progress {
    font-size: 13px;
    margin: 0 3px;
    padding-left: 10px;
    position: relative;
    text-transform: none;
    &:before {
      border-radius: 50%;
      content: "";
      height: 6px;
      left: 0;
      position: absolute;
      width: 6px;
      top: 5px;
    }
    &--physical:before {
      background-color: ${(props) => props.theme.primary.pissYellow};
    }
    &--financial:before {
      background-color: ${(props) => props.theme.primary.white};
    }
  }
`;

const WardProjectList = styled.div`
  h2 {
    font-size: clamp(1.5rem, 3.7vw, 2rem);
    margin: 30px 0 15px;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/localProject/list/index.js